const resetPassword = {
  resetPasswordTitle: 'אפס את הסיסמה שלך',
  resetNotSuccess: 'משהו השתבש. אנא נסה שוב\nאו פנה ל-michael@moovex.com',
  resetPasswordBtn: 'המשך',
  resetPasswordHint: 'אנא הזן סיסמה חדשה.',
  resetSuccessful: 'החלפת את הסיסמה בהצלחה.',
  backToLogIn: 'אנא חזור למסך הכניסה והתחבר מחדש',
  newPassword: 'סיסמה חדשה',
  reEnterPassword: 'אשר את הסיסמה שלך',
};

export default resetPassword;
